import { useStore } from '@/hooks/use-store';
import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';
import { useCallback } from 'react';

export const useUser = () => {
  const [{ user }, , mutate] = useStore();

  /**
   * Updates the current users information
   */
  const update = useCallback(async newData => {
    const res = await FrontendHttpClient.put('/api/v2/users/profile', newData);
    return res.data.record;
  }, []);

  const checkAccessKey = targetKey => {
    return user.accessKeys[targetKey].ACCESS;
  };

  const canAccess = accessKey => checkAccessKey(accessKey);

  const fetchDefaultProducer = async () => {
    // query user, then division
    if (!user?.defaultProducerId) {
      const currentDivision = await FrontendHttpClient.get(
        'api/v2/divisions/current'
      );

      const res = await FrontendHttpClient.get(
        `/api/v2/producer/${currentDivision.data.defaultProducerId}`
      );

      return res.data;
    } else if (user?.defaultProducerId) {
      const res = await FrontendHttpClient.get(
        `/api/v2/producer/${user?.defaultProducerId}`
      );
      return res.data;
    } else {
      return;
    }
  };

  const fetchDefaultSignature = async () => {
    // query user, then division
    if (!user?.defaultSignatureId) {
      const currentDivision = await FrontendHttpClient.get(
        'api/v2/divisions/current'
      );

      const res = await FrontendHttpClient.get(
        `api/v2/signatures/${currentDivision.data.defaultSignatureId}`
      );

      return res.data;
    } else if (user?.defaultSignatureId) {
      const res = await FrontendHttpClient.get(
        `/api/v2/signatures/${user?.defaultSignatureId}`
      );
      return res.data;
    } else {
      return;
    }
  };

  const fetchDefaultAgencyContact = async () => {
    if (!user?.defaultAgencyContactId) {
      return null;
    }
    const res = await FrontendHttpClient.get(
      `/api/v2/agency/${user?.defaultAgencyContactId}`
    );
    return res.data;
  };

  return {
    ...user,
    update,
    mutate,
    canAccess,
    fetchDefaultProducer,
    fetchDefaultSignature,
    fetchDefaultAgencyContact,
  };
};
